<div class="side-inner" >
  <!-- <div [class.open]="open"> -->
    <!-- <button role="button" title="close form" class="close-side-popup primary icon-button" (click)="goBack()"><fa-icon [icon]="faTimesIcon"></fa-icon></button> -->
    <button title="close form" class="close-popup-button close-button modal-close" (click)="goBack()">close</button>
    <lib-ng-demo id="quoteContainer" [productCode]="productCode" id="demoContainer" [productName]="'REST Generator'" style="right: 0;" (closeForm)="goBack()"></lib-ng-demo>
  <!-- </div> -->
  
</div>